class AudioSettings {

    constructor() {
        this.latency = 0;
    }

    getLatency() {
        return this.latency;
    }

    setLatency(latency) {
        this.latency = latency;
    }
}

export default AudioSettings;
